import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=279-23352&node-type=frame&m=dev)
 * */

const DrillDownIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_4259_40)"><path d="M9.09998 9.1L11.5 11.5M3.5 7V5M5.5 7V4M7.5 7V6M0.89836 7.45574C1.15519 8.06003 1.52853 8.60783 1.99707 9.06784C2.4656 9.52785 3.02016 9.89107 3.62907 10.1368C4.23797 10.3825 4.88931 10.5058 5.5459 10.4998C6.20248 10.4938 6.85144 10.3585 7.45574 10.1016C8.06003 9.84481 8.60783 9.47147 9.06784 9.00293C9.52785 8.5344 9.89107 7.97984 10.1368 7.37093C10.3825 6.76203 10.5058 6.11069 10.4998 5.4541C10.4938 4.79752 10.3585 4.14856 10.1016 3.54426C9.58295 2.32383 8.60068 1.35944 7.37093 0.863234C6.14119 0.367031 4.76469 0.379666 3.54426 0.89836C2.32383 1.41705 1.35944 2.39932 0.863234 3.62906C0.367031 4.85881 0.379666 6.23531 0.89836 7.45574Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" /></g>;
    t1 = <defs><clipPath><rect width="12" height="12" fill="white" /></clipPath></defs>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default DrillDownIcon;